import { CuraHeading, CuraParagraph } from '@rededor/cura-react'

import { IconDistance } from '@/components/IconDistance'
import { IconDate } from '@/components/IconDate'
import { UnitSuggestion } from '@/store/useFallbackStore'

import * as S from './styles'

interface Props {
  units: UnitSuggestion[]
  onClick: (unitId: UnitSuggestion['id']) => void
}

export const UnitsNearby = ({ units = [], onClick }: Props) => {
  const formatAddress = (unit: UnitSuggestion) => {
    return `${unit.street} - ${unit.neighborhood}, ${unit.city} - ${unit.state}`
  }

  return (
    <S.WrapperUnitsNearby>
      <S.WrapperHeading>
        <CuraHeading color="neutral-dark" size="small" marginBlock="0">
          Selecione uma unidade
        </CuraHeading>
        <S.Line />
      </S.WrapperHeading>
      <S.WrapperUnits>
        {units.map((unit) => (
          <S.Unit key={unit.id} onClick={() => onClick(unit.id)}>
            <IconDate date={unit.earliestDate} />
            <IconDistance distanceInMeters={unit.distance} />
            <S.WrapperTexts>
              <CuraHeading
                size="xsmall"
                color="primary"
                weight="bold"
                marginBlock="0"
              >
                {unit.name}
              </CuraHeading>
              <CuraParagraph size="xsmall" color="neutral-dark" marginBlock="0">
                <S.TruncateAddress>{formatAddress(unit)}</S.TruncateAddress>
              </CuraParagraph>
            </S.WrapperTexts>
          </S.Unit>
        ))}
      </S.WrapperUnits>
    </S.WrapperUnitsNearby>
  )
}
